module.exports = __webpack_public_path__ + "static/media/logo1.2197088d.svg";